import { format, formatDistanceToNow, isWithinInterval, sub } from "date-fns"
import { SOCIAL_NETWORK } from "../models/post"
import { TLatestSchedule } from "../store/managePost/newTypes"

export const getPublishDate = (schedule: TLatestSchedule): {[key in SOCIAL_NETWORK]: string} => {
    const isExistDate = schedule.date && schedule.time

    const date = isExistDate ? new Date(`${schedule.date}T${schedule.time}`) : new Date()

    const isCurrentYear = isExistDate && format(new Date(schedule.date), 'yyyy') === format(date, 'yyyy')

    const defaultSocialTimeFormat = {
        [SOCIAL_NETWORK.FACEBOOK_SOCIAL]: 'd LLLL, HH:mm',
        [SOCIAL_NETWORK.INSTAGRAM_SOCIAL]: 'LLLL d, HH:mm',
        [SOCIAL_NETWORK.TWITTER_SOCIAL]: 'LLL d HH:mm',
        [SOCIAL_NETWORK.LINKEDIN_SOCIAL]: 'd LLLL, HH:mm'
    }

    if (!isCurrentYear) {
        for (let [social, format] of Object.entries(defaultSocialTimeFormat)) {
            defaultSocialTimeFormat[social as SOCIAL_NETWORK] = format + ', yyyy'
        }
    }

    return {
        [SOCIAL_NETWORK.FACEBOOK_SOCIAL]: format(date, defaultSocialTimeFormat[SOCIAL_NETWORK.FACEBOOK_SOCIAL]),
        [SOCIAL_NETWORK.INSTAGRAM_SOCIAL]: format(date, defaultSocialTimeFormat[SOCIAL_NETWORK.INSTAGRAM_SOCIAL]),
        [SOCIAL_NETWORK.TWITTER_SOCIAL]: format(date, defaultSocialTimeFormat[SOCIAL_NETWORK.TWITTER_SOCIAL]),
        [SOCIAL_NETWORK.LINKEDIN_SOCIAL]: format(date, defaultSocialTimeFormat[SOCIAL_NETWORK.TWITTER_SOCIAL])
    }
}